var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTragOv1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24718 0.103991C11.0586 0.423392 12.8463 0.706158 14.5437 0.977064C16.2935 1.24865 17.4989 2.38308 17.8883 4.11256C18.2734 5.78975 18.6742 7.55879 19.113 9.344C19.5487 11.1842 19.2868 13.141 18.258 14.3677C17.246 15.5763 16.1696 16.7247 15.0286 17.813C13.8682 18.9169 11.929 19.3085 10.0679 18.9959C8.25645 18.6765 6.46876 18.3937 4.77138 18.1228C3.02153 17.8512 1.81617 16.7168 1.42674 14.9873C1.04161 13.3101 0.64083 11.5411 0.20203 9.75585C-0.23368 7.9156 0.0282544 5.95883 1.05707 4.73215C2.06903 3.52353 3.14549 2.37511 4.28647 1.28688C5.44688 0.182995 7.38604 -0.208694 9.24718 0.103991Z",
    fill: "#FABE07"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTragOv1);
export default __webpack_public_path__ + "static/media/trag-ov-1.3e17745c2988519193ede838d84076eb.svg";
export { ForwardRef as ReactComponent };